/**
 * Non-reactive buffer of resolved translations (key -> text) for the control panel's inline translation
 * editor. vue-i18n's `postTranslation` hook (config/vue-i18n.ts) records into it during render; keeping it
 * out of reactive state means recording never triggers a re-render (which would loop, since the panel
 * reads the list on every render) and never touches the Pinia store from inside a translate call (which
 * would instantiate it outside a setup context). The control-panel store reads a snapshot after render.
 * The buffer is never cleared, so it accumulates across navigations: the editor can review or edit any
 * translation key seen so far in the session, not just the ones on the current page.
 */
const buffer = new Map<string, string>()

export const recordTranslation = (key: string, translated: string) => {
  buffer.set(key, translated)
}

export const snapshotTranslations = (): Record<string, string> => Object.fromEntries(buffer)
